import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import CardMedia from "@material-ui/core/CardMedia";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import ImageUploader from "../../containers/ImageUploader/ImageUploader";

const secciones = [
	{
		value: "Geo",
		label: "Mapa"
	},
	{
		value: "Activity",
		label: "Actividades"
	},
	{
		value: "Information",
		label: "Información"
	},
	{
		value: "Promociones",
		label: "Promociones"
	},
	{
		value: "Favourites",
		label: "Favoritos"
	},
	{
		value: "DesignVillage",
		label: "Design Village"
	},
	,
	{
		value: "SolanasKids",
		label: "Solanas Kids"
	},
	{
		value: "CrystalBeach",
		label: "Crystal Beach"
	},
	{
		value: "GardensView",
		label: "Gardens View"
	},
	{
		value: "GreenPark",
		label: "Green Park"
	},
	{
		value: "ConventionCenter",
		label: "Convention Center"
	},
	{
		value: "CrystalView",
		label: "Crystal View"
	},
	{
		value: "Kalhua",
		label: "Kalhua"
	},
	{
		value: "Link",
		label: "Link"
	}
];

class PrincipalEdit extends Component {
	state = {
		data: "",
		title: "",
		info: "",
		fieldValues: {
			image: ""
		}
	};

	componentDidMount() {
		this.state = {
			data: this.props.info,
			modal: false,
			edit: false,
			deletedImage: false
		};

		this.setState({
			title: this.props.titulo,
			descripcion: this.props.descripcion,
			seccion: this.props.seccion,
			image: this.props.image,
			link: this.props.link,
			id: this.props.id
		})
	}

	handleConfirm = () => {
		this.props.handleDelete({ id: this.props.id }, this.props.token);
		this.setState({
			modal: false
		});
	};

	handleEdit = () => {
		if(this.state.deletedImage == true) {
			this.props.handleSaveEdit(
				{
					titulo: this.state.title,
					descripcion: this.state.descripcion,
					seccion: this.state.seccion,
					image: this.state.fieldValues.image,
					link: this.state.link,
					id: this.props.id
				},
				this.props.token
			);
			this.setState({
				modal: false,
				edit: false,
				deletedImage: false
			});
		}else{
			this.props.handleSaveEditNoImage(
				{
					titulo: this.state.title,
					descripcion: this.state.descripcion,
					seccion: this.state.seccion,
					link: this.state.link,
					id: this.props.id
				},
				this.props.token
			);
			this.setState({
				modal: false,
				edit: false,
				deletedImage: false
			});
		}
	};

	handleCancel = () => {
		this.setState({
			modal: false
		});
	};

	handleCancelEdit = () => {
		this.setState({
			edit: false
		});
	};


	openModal = () => {
		console.log("OPENM MODAL");
		this.setState({
			modal: true
		});
	};

	openEdit = () => {
		console.log("OPENM EDIT");
		this.setState({
			edit: true
		});
	};

	deleteImage = () => {
		console.log("DELETE IMAGE");
		this.setState({
			deletedImage: true
		});
	};

	render() {
		return (
			<React.Fragment>
				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.modal}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "20% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Desea Borrar?
							<br />
							<br />
							<br />
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="secondary"
								variant="contained"
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button
								onClick={this.handleCancel}
								color="primary"
								variant="contained"
							>
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>

				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.edit}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "20% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Desea sobreescribir el item con estos cambios?
							<br />
							<br />
							<br />
							<Button
								onClick={this.handleEdit}
								type="submit"
								color="secondary"
								variant="contained"
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button
								onClick={this.handleCancel}
								color="primary"
								variant="contained"
							>
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>

				<Card style={{ width: "100%", marginBottom: 10 }}>
					<CardContent>
						<TextField
							id="outlined-basic"
							label="Titulo"
							variant="outlined"
							defaultValue={this.props.titulo}
							onChange={value => this.setState({ title: value.target.value })}
							style={{ width: "90%" }}
						/>
						<br />
						<br />
						<TextField
							id="outlined-basic"
							label="Descripción"
							variant="outlined"
							multiline
							defaultValue={this.props.descripcion}
							onChange={value => this.setState({ descripcion: value.target.value })}
							style={{ width: "90%" }}
						/>
						<br />
						<br />
						<TextField
								id="standard-select"
								select
								label="Sección"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								defaultValue={this.props.seccion}
								onChange={value =>
									this.setState({ seccion: value.target.value })
								}
							>
								{secciones.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
						<br />
						<br />
						<TextField
									id="outlined-basic"
									label="Link"
									variant="outlined"
									multiline
									defaultValue={this.props.link}
									onChange={value => this.setState({ link: value.target.value })}
									style={{ width: "90%" }}
								/> 
						<br />
						<br />	
						{
								this.state.deletedImage == true ? 
								<ImageUploader fieldValues={this.state.fieldValues} />
								: 
								<CardMedia
								image={this.props.imagen}
								title="Imagen"
								style={{ width: "200px", height: "200px", marginLeft: "5%" }}
							/>}

						<br />
						<br />	
						{
								this.state.deletedImage == true ? 
								null
								: 
								<Button
								color="secondary"
								onClick={() => {
								this.deleteImage();
								}}>
									Borrar Imagen
								</Button>
						}
						<br />
						<br />	

					</CardContent>

					<CardActions>
						<Button
							color="secondary"
							onClick={() => {
								this.openEdit();
							}}
						>
							Guardar Cambios
						</Button>
						<Button
							color="secondary"
							onClick={() => {
								this.openModal();
							}}
						>
							Borrar
						</Button>
					</CardActions>
				</Card>
			</React.Fragment>
		);
	}
}
export default PrincipalEdit;
